var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.teachingMaterialChip ? _c('div', [_vm._v(_vm._s(_vm.teachingMaterialChip.category) + " - " + _vm._s(_vm.teachingMaterialChip.name))]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }